module.exports = __webpack_public_path__ + "static/media/BRC_1650578.1cbb8cd6.png";